import { gsap } from 'gsap';
import ControllerBringSymbolsToFront from './ControllerBringSymbolsToFront';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';
import GradientOverlay from '../../gradientOverlay/gradientOverlay';

export default class ControllerWinCombination {
  constructor({ reelsContainer, controllerReels, topContainer }) {
    this.ControllerReels = controllerReels;
    this.containerReels = reelsContainer;
    this.ControllerBringToFrontSymbols = new ControllerBringSymbolsToFront(topContainer);
    this._initOverlay();
    this._soundPlayed = false;
    this._sounds = [eSounds.EST_WIN, eSounds.EST_WIN_1, eSounds.EST_WIN_2, eSounds.EST_WIN_3, eSounds.EST_WIN_4];
  }

  showCombination({ params }) {
    this._setAllSymbolsActive(false);
    this.overlay.visible = true;
    gsap.to(this.overlay, { alpha: 1, duration: 0.2 });
    let sound = this._sounds[0];

    params.path.forEach((pathData, index) => {
      if (pathData >= 0) {
        const symbol = this.ControllerReels.reels[index].symbols[pathData];
        this.ControllerBringToFrontSymbols.bringToFront(symbol);
        symbol.setActive(true);
        symbol.startAnimation();
        sound = this._sounds[symbol.id] || sound;
      }
    });

    if (!this._soundPlayed) {
      SoundManager.play(sound.soundName, sound.volume, false, sound.group);
      this._soundPlayed = true;
    }
  }

  showBonusGameStart(symbols) {
    this._setAllSymbolsActive(false);
    this.overlay.visible = true;
    gsap.to(this.overlay, { alpha: 1, duration: 0.2 });
    symbols.forEach(symbol => {
      this.ControllerBringToFrontSymbols.bringToFront(symbol);
      symbol.setActive(true);
      symbol.startAnimation();
    });
  }

  end() {
    this._soundPlayed = false;
    this._setAllSymbolsActive(true);
    this.ControllerBringToFrontSymbols.bringAllBack();
    if (this.overlay.visible) {
      gsap.to(this.overlay, {
        alpha: 0, duration: 0.2, onComplete: () => {
          this.overlay.visible = false;
        }
      });
    }
  }

  _setAllSymbolsActive(value) {
    this.ControllerReels.reels.forEach(reel => reel.symbols.forEach(symbol => {
      symbol.stopAnimation();
      symbol.setActive(value);
    }));
  }

  _initOverlay() {
    // this.overlay = new PIXI.Graphics();
    this.overlay = new PIXI.Container();
    const gradientOverlay =  new GradientOverlay();
    gradientOverlay.updateSize( 1240, 801);
    gradientOverlay.gradientSprite.x = 1240/2
    gradientOverlay.gradientSprite.y = 801/2;

    this.overlay.addChild(gradientOverlay.gradientSprite);
    const mask = new PIXI.Graphics();
    mask.beginFill(0x080342, 1);
    // mask.drawRoundedRect(-20, -20, 1180, 840, 34);
    mask.drawRoundedRect(0, 0, 1240, 801,4,);
    mask.endFill();
    this.overlay.addChild(mask);
    gradientOverlay.gradientSprite.mask = mask;
    this.containerReels.addChildAt(this.overlay, 0);

    // this.overlay.beginFill(0x080342, 0.75);
    // this.overlay.drawRoundedRect(-20, -20, 1180, 840, 34);
    // this.overlay.beginTextureFill({ texture: gradientOverlay.gradientSprite.texture })
    // this.overlay.endFill();
    this.overlay.visible = false;
  }
}
